module.exports = __webpack_public_path__ + "img/C8.485bc2d8.webp";